import React, { useState } from 'react';
import TextInputField from '../../Clinic/InputFields/TextInputField';
import CheckboxInputField from '../../Clinic/InputFields/CheckboxInputField';
import RadioInputField from '../../Clinic/InputFields/RadioInputField';
import DropdownInputField from '../../Clinic/InputFields/DropdownInputField';
import EmailInputField from '../../Clinic/InputFields/EmailInputField';
import DuedateInputField from '../../Clinic/InputFields/DuedateInputField';
import MobileInputField from '../../Clinic/InputFields/MobileInputField';
import Theme from '../../AddressPage/Theme';
import { validationHandler } from '../../Clinic/HealthPlan/common';
import { formSubmit } from '../../../datafetchers/IVFPage';
import { Toast } from '../../Clinic/HealthPlan/styled';
import { getCountryOnBasisOfUrl } from '../../../Utils/ForeignUtils';
import { setItemsInCookies } from '../../Clinic/common';
import { firePopupEvents } from './instrumentation';
import * as crypto from 'crypto-js';
import Cookies from 'js-cookie';
import { getSearchQueryParamsWithoutAD } from '../../../Utils/helper';

function DynamicFields(props) {
  const {
    formData,
    template,
    skuId,
    skuName,
    setShowSubmitted,
    setBookingDone,
    setLeadId,
    fromPdp,
  } = props;
  const [showToast, setShowToast] = useState(false);
  const [cardEffect, setCardEffect] = useState('');
  const isUae = getCountryOnBasisOfUrl() === 'UAE';
  const inputFieldErrorHandler = (value, index) => {
    let e = value?.trim();
    formData?.questions?.map((element, i) => {
      if (index == i) {
        element['answer_text'] = e;
      }
    });
  };
  const commonProps = {
    inputFieldErrorHandler,
  };
  const country_code = getCountryOnBasisOfUrl();

  const SubmitHandler = async (event) => {
    event?.preventDefault();
    setCardEffect('lowOpacity');
    firePopupEvents('clicked_cta', 'request_callback');
    let errorCount = 0;
    formData?.questions?.map((element, i) => {
      if (
        !validationHandler(
          element?.validation_type,
          element['answer_text'],
          isUae,
        ) ||
        element['answer_text']?.length == 0
      ) {
        errorCount++;
      }
    });

    const query_string = getSearchQueryParamsWithoutAD();
    let payload = {
      form_id: formData?.form?.id,
      sku_id: skuId,
      sku_name: skuName,
      form_response: formData?.questions,
      query_string,
      form_type: fromPdp ? 'sku' : 'article',
    };
    if (errorCount == 0) {
      const ApiResponse = await formSubmit(payload, {}, country_code);
      formData?.questions?.map((ques) => {
        if (ques?.validation_type == '2' && setLeadId) {
          const encodedWord = crypto.enc.Utf8.parse(ques?.answer_text); // encodedWord Array object
          const encoded = crypto.enc.Base64.stringify(encodedWord);
          Cookies?.set(`userLead-${setLeadId}`, encoded);
        }
      });
      if (ApiResponse?.success) {
        firePopupEvents('consultation_confirmed');
        setShowSubmitted(true);
        setItemsInCookies(skuId, formData);
        setBookingDone(true);
      }
    } else {
      setShowToast(true);
      setTimeout(
        function () {
          setShowToast(false);
        },
        [1000],
      );
    }
  };
  return (
    <>
      {showToast ? (
        <Toast>
          <p>Invalid Input Fields</p>
        </Toast>
      ) : null}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          setTimeout(() => {
            SubmitHandler(e);
          }, 100);
        }}
      >
        <Theme>
          <div>
            {formData?.questions?.map((element, index) => {
              switch (element?.type) {
                case '1':
                  return (
                    <TextInputField
                      element={element}
                      index={index}
                      {...commonProps}
                      fromPdp={true}
                    />
                  );

                case '2':
                  return (
                    <CheckboxInputField
                      element={element}
                      index={index}
                      {...commonProps}
                    />
                  );

                case '3':
                  return (
                    <RadioInputField
                      element={element}
                      index={index}
                      {...commonProps}
                      fromPdp={true}
                    />
                  );
                case '4':
                  return (
                    <DropdownInputField
                      element={element}
                      index={index}
                      {...commonProps}
                      fromPdp={true}
                    />
                  );
                case '5':
                  return (
                    <EmailInputField
                      element={element}
                      index={index}
                      {...commonProps}
                      fromPdp={true}
                    />
                  );

                case '6':
                  return (
                    <DuedateInputField
                      element={element}
                      index={index}
                      {...commonProps}
                      fromPdp={true}
                    />
                  );
                case '7':
                  return (
                    <MobileInputField
                      element={element}
                      index={index}
                      {...commonProps}
                      fromPdp={true}
                    />
                  );

                default:
                  break;
              }
            })}
          </div>
        </Theme>
        {template(cardEffect)}
      </form>
    </>
  );
}

export default DynamicFields;
